/** Web: GPS sólo si el permiso YA está concedido — el chat nunca dispara el prompt. */
import type { LecturaGps } from './posicion';

export async function leerPosicionDispositivo(): Promise<LecturaGps | null> {
  try {
    if (typeof navigator === 'undefined' || !navigator.geolocation || !navigator.permissions?.query) return null;
    const perm = await navigator.permissions.query({ name: 'geolocation' as PermissionName });
    if (perm.state !== 'granted') return null;
    return await new Promise<LecturaGps | null>((resolve) => {
      navigator.geolocation.getCurrentPosition(
        (pos) => resolve({ lng: pos.coords.longitude, lat: pos.coords.latitude, accuracy: pos.coords.accuracy, timestamp: pos.timestamp }),
        () => resolve(null),
        { maximumAge: 60_000, timeout: 2_000, enableHighAccuracy: false },
      );
    });
  } catch {
    return null;
  }
}
